import { render, staticRenderFns } from "./stock-op.vue?vue&type=template&id=6f8cf3da&"
import script from "./stock-op.vue?vue&type=script&lang=js&"
export * from "./stock-op.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.1_css-loader@5.2.7_vue-template-compiler@2.6.11_webpack@5.75.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports